<style scoped>
.title{
    background-color: #F5F6EA;
  border-bottom: 10px solid lightgray;
}
.header{
    text-align: center;
    font-size: 40px;
    color: #03533f;
    font-weight: bold;
    padding-top: 30px;
}
.subheader{
    text-align: center;
    font-size: 20px;
    color: #03533f;
    font-weight: bold;
    padding-bottom: 30px;
}
.home-img{
    width: auto;
    max-height: 600px;
}
.foother-href{
  font-size: 14px;
  color: #2d8cf0 !important;
}
</style>

<template>
    <div>
        <row class="title">
            <i-col span="24" class="header">
                青岛地铁广告资源经营管理系统
            </i-col>
            <i-col span="24" class="subheader">
                Qingdao Metro Media Resource Management System
            </i-col>
        </row>
        <Row>
            <i-col span="16" class="text-center">
                <img class="home-img" src="../../assets/qdmetro/home.jpg"/>
            </i-col>
            <i-col span="8">
                <Alert v-show="isInvaild" type="error" style="margin: 0 30px;">无效用户！请联系管理员，将您添加至有效用户。</Alert>
                <Card v-show="showBinduser" :bordered="false" dis-hover class="p-t-50 p-r-30">
                    <bindUser :wxUid="wxUid" :appid="appid"/>
                </Card>
                <div v-show="!showBinduser" id="wxframe" class="m-t-100"></div>
            </i-col>
        </Row>
        <p class="text-center p-t-50">
          Copyright © 2019~2020 青岛地铁资产经营管理有限公司. All Rights Reserved <a class="foother-href" href="http://www.beian.miit.gov.cn" target="_Blank"> 鲁ICP备20012040号-1</a>
        </p>
    </div>
</template>

<script>
import { getUrlQuery } from '@/utils/common.js'
import bindUser from '@/components/bindUser'
const CryptoJS = require('crypto-js')

export default {
  name: 'wxlogin',
  components: {
    bindUser
  },
  data () {
    return {
      isInvaild: false,
      appid: 'ww14084958232d3a75',
      wxUid: '',
      showBinduser: false
    }
  },
  mounted () {
    // 页面初始化操作
    this.init()
  },
  methods: {
    init () {
      this.showBinduser = false
      this.initWxLogin()

      var code = getUrlQuery('code', window.location.href)
      if (code) {
        // 如果URL中包含CODE代码， 那么根据情况调整页面
        let scanBean = {
          appId: this.appid,
          code: code
        }

        this.$store.dispatch('LoginByScan', scanBean).then((data) => {
          const privateKey = data.privateKey
          const urlLoader = data.url
          // 加密登录信息,直接传输UserId
          const token = {
            Uid: data.scanUserId,
            AppId: this.appid,
            website: process.env.WEBSIT,
            type: data.type
          }

          const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(token), privateKey).toString()
          window.location.href = urlLoader + '?token=' + encodeURIComponent(ciphertext)
        }).catch((error) => {
          // CODE为未绑定的用户
          if (error.errcode === -7) {
            this.showBinduser = true
            this.wxUid = error.errmsg
          } else { // 企业微信未添加改用户至可信任区域
            this.isInvaild = true
          }
        })
      }
    },
    initWxLogin () {
      window.WwLogin({
        id: 'wxframe',
        appid: this.appid,
        agentid: '1000002',
        scope: 'snsapi_login',
        redirect_uri: 'http://www.qdmetromrms.com/qdmetroLogin', // 转到当前地址以获取code值
        state: Math.random(),
        href: ''
      })
    }
  }
}
</script>
